import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { ArrowRight, Calendar, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { Card } from '../components/ui/Card';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
export function ServicesPage() {
  const {
    t,
    lang
  } = useTranslation();
  const seoTitle = lang === 'en' ? 'Dental Services in Angel, London | Dentico Clinic' : lang === 'ua' ? 'Стоматологічні послуги в Angel, Лондон | Dentico Clinic' : lang === 'ro' ? 'Servicii Dentare în Angel, Londra | Dentico Clinic' : 'Стоматологические услуги в Angel, Лондон | Dentico Clinic';
  const seoDescription = lang === 'en' ? 'Explore private dental services at Dentico Clinic in Angel, including hygiene, fillings, veneers, implants, orthodontics and emergency care.' : lang === 'ua' ? 'Ознайомтеся з приватними стоматологічними послугами в Dentico Clinic в Angel, включаючи гігієну, пломби, вініри, імпланти, ортодонтію та невідкладну допомогу.' : lang === 'ro' ? 'Explorați serviciile dentare private la Dentico Clinic din Angel, inclusiv igienă, plombe, fațete, implanturi, ortodonție și îngrijire de urgență.' : 'Ознакомьтесь с частными стоматологическими услугами в Dentico Clinic в Angel, включая гигиену, пломбы, виниры, импланты, ортодонтию и неотложную помощь.';
  const services = [{
    id: 'fillings',
    title: t('services.fillings.title'),
    description: t('services.fillings.desc'),
    image: 'https://drive.google.com/thumbnail?id=1GoYPTv2Ah2lfohOV_wcv06DwMvJ8-YIf&sz=w1200'
  }, {
    id: 'root-canal',
    title: t('services.rootCanal.title'),
    description: t('services.rootCanal.desc'),
    image: 'https://drive.google.com/thumbnail?id=1oecjcYpi0WMZbrhKFXRxj1Z597Vlnj1m&sz=w1200'
  }, {
    id: 'crowns',
    title: t('services.crowns.title'),
    description: t('services.crowns.desc'),
    image: 'https://cdn.magicpatterns.com/uploads/ns891AKGuZCaDei6mehiRt/ChatGPT_Image_Sep_28,_2026,_08_24_38_PM-2.png'
  }, {
    id: 'hygiene',
    title: t('services.hygiene.title'),
    description: t('services.hygiene.desc'),
    image: 'https://cdn.magicpatterns.com/uploads/4h5wQ8THmt6sSAX8agbB73/ChatGPT_Image_Sep_28,_2026,_08_24_39_PM-3.png'
  }, {
    id: 'whitening',
    title: t('services.whitening.title'),
    description: t('services.whitening.desc'),
    image: 'https://cdn.magicpatterns.com/uploads/4kRqTAaJ1u6tJq3cB7gSSs/ChatGPT_Image_Sep_28,_2026,_08_24_36_PM-1.png'
  }, {
    id: 'extraction',
    title: t('services.extraction.title'),
    description: t('services.extraction.desc'),
    image: 'https://drive.google.com/thumbnail?id=1H9Sf4ZxWwyVlbdh7GXl7iGQTbjS1U2mD&sz=w1200'
  }, {
    id: 'smile-makeover',
    title: t('services.smileMakeover.title'),
    description: t('services.smileMakeover.desc'),
    image: 'https://cdn.magicpatterns.com/uploads/aws3cmiUVaQNLxKjpQRh73/IMG_3720.jpg'
  }, {
    id: 'cosmetic',
    title: t('services.cosmetic.title'),
    description: t('services.cosmetic.desc'),
    image: 'https://drive.google.com/thumbnail?id=1WfQHZfd0cw_7cJJrW6R75IqRiZXZJ9Yb&sz=w1200'
  }, {
    id: 'paediatric-dentistry',
    title: t('services.paediatric.title'),
    description: t('services.paediatric.desc'),
    image: 'https://drive.google.com/thumbnail?id=1EkX5ZapNGT_ssdlSh1hBhv8Yym2-cS-j&sz=w1200'
  }];
  return <Layout title={seoTitle} description={seoDescription} data-id="element-4076" data-mp="1b3yvef61mnhz">
      <div className="bg-forest-900 py-16 lg:py-20 text-white" data-id="element-4077" data-mp="3ht3lzgi2bl9s">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-4078" data-mp="3hvq2w6qufd4o">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-4079" data-mp="3cwmwoiz4n0v4">
            {t('servicesPage.title')}
          </h1>
          <p className="text-xl text-ivory/80 max-w-2xl mx-auto" data-id="element-4080" data-mp="3eebufgwcvpsv">
            {t('servicesPage.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-id="element-4081" data-mp="3o9vlnpzz60ba">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4082" data-mp="3t8ymszcu3mdz">
          {services.map(service => <Card key={service.id} hover className="overflow-hidden flex flex-col h-full border-0 shadow-lg" data-id="element-4083" data-mp="2vlzsgv9m6qj9">
              <Link to={`/${lang}/services/${service.id}`} className="block" data-id="element-4084" data-mp="30i82ju8yftjk">
                <div className="relative aspect-[4/3] overflow-hidden" data-id="element-4085" data-mp="35ico3yopzegn">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-4086" data-mp="3ab5s2kcd6iro" />
                </div>
              </Link>

              <div className="p-6 flex flex-col flex-grow" data-id="element-4087" data-mp="yzgrcth1apjs">
                <Link to={`/${lang}/services/${service.id}`} data-id="element-4088" data-mp="ywujstu58a1k">
                  <h2 className="text-xl font-bold text-charcoal mb-3 hover:text-forest-600 transition-colors" data-id="element-4089" data-mp="uyoiw2fzkook">
                    {service.title}
                  </h2>
                </Link>
                <p className="text-charcoal-light mb-6 text-sm line-clamp-2 flex-grow" data-id="element-4090" data-mp="ky4ews13162n">
                  {service.description}
                </p>

                <div className="flex gap-3 mt-auto" data-id="element-4091" data-mp="g1xj3s2ehayf">
                  <Link to={`/${lang}/services/${service.id}`} className="flex-1" data-id="element-4092" data-mp="b8ktbelziy43">
                    <Button variant="outline" size="sm" fullWidth data-id="element-4093" data-mp="75eombeitezq">
                      {t('services.learnMore')}
                    </Button>
                  </Link>
                  <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="flex-1" data-id="element-4094" data-mp="3tehdcnl2d5xq">
                    <Button size="sm" fullWidth data-id="element-4095" data-mp="3eqpfjsr5to1e">
                      {t('nav.bookOnline')}
                    </Button>
                  </a>
                </div>
              </div>
            </Card>)}
        </div>
      </div>

      <div className="bg-ivory-200 py-16 lg:py-20" data-id="element-4096" data-mp="39t7f6qr7kh50">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-4097" data-mp="39tz1tc2tv4j5">
          <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-4098" data-mp="1cvsonkexd2u">
            {t('servicesPage.readyToBook')}
          </h2>
          <p className="text-charcoal-light mb-8" data-id="element-4099" data-mp="6bffsraqsuws">
            {t('servicesPage.readyToBookDesc')}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-4100" data-mp="3opygj5kg02x9">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-4101" data-mp="3sr9zwtcq3rx0">
              <Button size="lg" className="gap-2 w-full sm:w-auto" data-id="element-4102" data-mp="kci317dh4b9a">
                <Calendar className="w-5 h-5" data-id="element-4103" data-mp="ka5do95dyym7" />
                {t('servicesPage.bookOnlineNow')}
              </Button>
            </a>
            <a href="https://wa.me/447345197820" target="_blank" rel="noopener noreferrer" data-id="element-4104" data-mp="29svhledhsyfw">
              <Button variant="whatsapp" size="lg" className="gap-2 w-full sm:w-auto" data-id="element-4105" data-mp="24u0qlp5dg3kp">
                WhatsApp
              </Button>
            </a>
            <Link to={`/${lang}/contact`} data-id="element-4106" data-mp="2em6qdl1v7pag">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-4107" data-mp="1qtpy6hoeygxf">
                {lang === 'en' ? 'Request a Call' : lang === 'ua' ? 'Замовити дзвінок' : lang === 'ru' ? 'Заказать звонок' : 'Solicitați un Apel'}
              </Button>
            </Link>
            <Link to={`/${lang}/prices`} data-id="element-4108" data-mp="3c9ypikkhh0ko">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-4109" data-mp="379atfkhedtjl">
                {lang === 'en' ? 'View Prices' : lang === 'ua' ? 'Переглянути ціни' : lang === 'ru' ? 'Посмотреть цены' : 'Vedeți Prețurile'}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>;
}